import { Controller } from "@hotwired/stimulus";
import { track } from "../analytics";

export default class extends Controller {
  connect() {
    const projectId = this.element.dataset.projectId;
    const projectName = this.element.dataset.projectName;
    const projectType = this.element.dataset.projectType;

    // Track project page view
    track("project_viewed", {
      project_id: projectId,
      project_name: projectName,
      project_type: projectType,
    });
  }

  trackProjectLinkClick(event) {
    const projectId = this.element.dataset.projectId;
    const projectName = this.element.dataset.projectName;
    const url = event.target.href;

    track("project_link_clicked", {
      project_id: projectId,
      project_name: projectName,
      url: url,
    });
  }

  trackScreenshotView(event) {
    const modal = event.target;
    const image = modal.querySelector("img");
    const src = image?.src || "";

    // Extract screenshot index from src if possible
    const match = src.match(/screenshot[_-]?(\d+)/i);
    const screenshotIndex = match ? parseInt(match[1], 10) + 1 : null;

    track("screenshot_viewed", {
      project_id: this.element.dataset.projectId,
      project_name: this.element.dataset.projectName,
      screenshot_index: screenshotIndex,
    });
  }
}
